jQuery(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
  
      
    
      const waitFor = setInterval(function(){
        // if exists AVADA_SC.appStatus and is true 
        if(typeof AVADA_SC !== "undefined" && AVADA_SC.appStatus){
          clearInterval(waitFor);
          setTimeout(function(){
            initLocationAvadaSizePlugin()
          },600)
        }
      }, 300)
});

/* avada size plugin - on product page, change position of button */

function initLocationAvadaSizePlugin(){
  console.log("testing avada")
  // create link
  var btn = document.createElement("a");
  // onc lick
  btn.setAttribute("href", "javascript:openAvadaSizePlugin()");
  // add class
  btn.classList.add("avada-size-custom-btn");
  // link
  btn.innerText = "Velikostní tabulka";

  // padding-bottom: 10px;
  // display: inline-block;
  // transform: translateY(-6px);
  btn.style.paddingBottom = "10px";
  btn.style.display = "inline-block";
  btn.style.transform = "translateY(-6px)";
  btn.style.width = "100%";

  
  // add after .t4s-swatch
  var swatch = document.querySelector(".t4s-swatch");
  // if swatch exists
  if(swatch){
    swatch.after(btn);
  }
  // invisible
  document.querySelector("#Avada-SC-button").style.display = "none";

}
function openAvadaSizePlugin(){
  document.querySelector(".Avada-inline-button a").click()
  if(window.matchMedia("(max-width: 767px)").matches){
    document.querySelector(".Avada-inline-button a").click()
  }
}




/* product detail slider - image alt show over photo*/
let productDetailImageTitle__IsInited = false;
function productDetailImageTitle(){
    if(productDetailImageTitle__IsInited){
        return;
    }
    productDetailImageTitle__IsInited = true;

    const slides = document.querySelectorAll('.flickityt4s-slider .t4s-product__media-item');
    if(slides.length === 0) {
        return;
    }
    slides.forEach(slide => {
        const image = slide.querySelector('img');
        const alt = image ? image.alt:""
        
        
        if(alt){
            // append span.product-thumbnail__title to slide
            const span = document.createElement("span");
            span.innerHTML = alt;
            span.classList.add("product-thumbnail__title")
            slide.querySelector(".t4s-product__media").appendChild(span)
        }

    })
}

$(document).ready(function () {
    productDetailImageTitle()
    setTimeout(() => { productDetailImageTitle() }, 1000);
    setTimeout(() => { productDetailImageTitle() }, 5000);
});
